import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { site } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-8 px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:gap-10 lg:py-14">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-700">
              <i className="ri-eye-line text-lg" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-lg font-bold text-background-50">{site.shortName}</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-200">{site.desc}</p>
        </div>

        <nav aria-label="栏目导航">
          <h3 className="font-heading text-sm font-semibold text-accent-300">栏目导航</h3>
          <ul className="mt-4 space-y-2.5">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/category/${c.slug}`}
                  className="cursor-pointer text-sm text-background-200 transition-colors hover:text-background-50"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="快捷入口">
          <h3 className="font-heading text-sm font-semibold text-accent-300">快捷入口</h3>
          <ul className="mt-4 space-y-2.5">
            <li>
              <Link to="/" className="cursor-pointer text-sm text-background-200 transition-colors hover:text-background-50">
                事件首页
              </Link>
            </li>
            <li>
              <Link to="/faq" className="cursor-pointer text-sm text-background-200 transition-colors hover:text-background-50">
                常见问题
              </Link>
            </li>
            <li>
              <Link to="/about" className="cursor-pointer text-sm text-background-200 transition-colors hover:text-background-50">
                关于本站与信息分级
              </Link>
            </li>
            <li>
              <Link to="/article/timeline-full" className="cursor-pointer text-sm text-background-200 transition-colors hover:text-background-50">
                完整时间线
              </Link>
            </li>
          </ul>
        </nav>

        <div>
          <h3 className="font-heading text-sm font-semibold text-accent-300">联系与说明</h3>
          <p className="mt-4 text-sm leading-relaxed text-background-200">
            内容纠错、来源补充或线索投稿，欢迎来信。
          </p>
          <a
            href={`mailto:${site.email}`}
            className="mt-3 inline-flex cursor-pointer items-center gap-2 text-sm text-background-50 hover:text-accent-300"
          >
            <i className="ri-mail-line" aria-hidden="true"></i>
            {site.email}
          </a>
          <p className="mt-5 text-xs leading-relaxed text-background-300">
            本站内容均整理自公开渠道，仅供信息参考。请以当事人与相关平台的官方最新公告为准。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex max-w-content flex-col gap-2 px-4 py-5 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between md:px-6">
          <p>© {year} {site.name}. 保留所有权利。</p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-1">
            <span>中立梳理 · 标注来源 · 拒绝传谣</span>
          </p>
        </div>
      </div>
    </footer>
  );
}